module.exports = __webpack_public_path__ + "static/media/jrCol.3700e318.png";